export default __webpack_public_path__ + "static/media/blog-shape.046d72da.svg";